import React, { useEffect, useRef, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import BootstrapTable from 'react-bootstrap-table-next';
import CardBasic from '../../../components/Cards/Basic';
import DatePicker from '../../../components/DatePicker';
import { formatCurrency, formatDateOnly } from '../../../constants/utility';
import PageHeading from '../../../components/PageHeading';
import PrintingHeader from '../../../components/PrintingHeader';
import { useReactToPrint } from 'react-to-print';
import { CSVLink, CSVDownload } from 'react-csv';
import moment from 'moment';

import * as actions from '../../../redux/actions';
import { fetchBonusHarian } from '../../../redux/actions/report';

const BonusHarian = (props) => {
  const { name, title, parent } = props.data;
  const { bonusHarian, formResult } = useSelector((state) => state.report);
  const { public_id } = useSelector((state) => state.auth.data);
  const [show, setShow] = useState(false);
  const dispatch = useDispatch();
  let date = new Date();
  const [filterDate, setFilterDate] = useState({
    start: new Date(date.getFullYear(), date.getMonth(), 1),
    end: new Date(),
  });

  const csvLink = useRef(); // setup the ref that we'll use for the hidden CsvLink click once we've updated the data
  const getTransactionData = async () => {
    csvLink.current.link.click();
  };

  const getReport = () => {
    const params = {
      id: public_id,
      filter: {
        tanggal: {
          op: 'between',
          value: {
            from: moment(filterDate.start).format('YYYY-MM-DD'),
            to: moment(filterDate.end).format('YYYY-MM-DD'),
          },
        },
      },
    };
    dispatch(fetchBonusHarian(params));
  };

  const printRef = useRef();
  const handlePrint = useReactToPrint({
    content: () => printRef.current,
  });

  useEffect(() => {
    dispatch(
      actions.setMenuActive({ menuActive: parent || name, subMenuActive: name })
    );
  }, [dispatch, formResult, name, parent]);

  const columns = [
    {
      dataField: '_',
      text: 'No',
      headerClasses: 'py-2 px-2 text-center',
      classes: 'p-2',
      headerStyle: (colum, colIndex) => {
        return { width: '40px' };
      },
      formatter: (cel, row, rowIndex) => rowIndex + 1,
      footer: '',
      footerClasses: 'text-center',
      classes: 'p-2 text-center',
    },
    {
      dataField: 'tanggal',
      text: 'Tanggal',
      headerStyle: (colum, colIndex) => {
        return { width: '90px' };
      },
      headerClasses: (column, colIndex) => {
        return 'py-2 px-2 text-left';
      },
      classes: (column, colIndex) => {
        return 'p-2';
      },
      formatter: (val) => (val ? formatDateOnly(val, false, false, true) : '-'),
      footer: '',
    },
    {
      dataField: 'jenis_bonus',
      text: 'Jenis Bonus',
      headerClasses: 'py-2 px-2 text-center',
      headerStyle: { width: '160px' },
      classes: 'p-2 text-left',
      footerClasses: 'text-left',
      footer: 'Total',
    },
    {
      dataField: 'bonus_bruto',
      text: 'Bonus Bruto',
      headerClasses: 'py-2 px-2 text-center',
      headerStyle: { width: '160px' },
      classes: 'p-2 text-center',
      formatter: (val) => formatCurrency(val),
      footerClasses: 'text-center',
      footer: (row) => formatCurrency(row.reduce((a, b) => a + b, 0)),
    },
    {
      dataField: 'pph',
      text: 'Potongan PPH',
      headerClasses: 'py-2 px-2 text-center',
      headerStyle: { width: '160px' },
      classes: 'p-2 text-center',
      formatter: (val) => formatCurrency(val),
      footerClasses: 'text-center',
      footer: (row) => formatCurrency(row.reduce((a, b) => a + b, 0)),
    },
    {
      dataField: 'bonus_dibayar',
      text: 'Bonus Bersih',
      headerClasses: 'py-2 px-2 text-center',
      headerStyle: { width: '160px' },
      classes: 'p-2 text-center',
      formatter: (val) => formatCurrency(val),
      footerClasses: 'text-center',
      footer: (row) => formatCurrency(row.reduce((a, b) => a + b, 0)),
    },
  ];

  return (
    <div>
      <PageHeading title={title} />
      <CardBasic nopadding>
        <div className="d-flex justify-content-between m-2">
          <div className="d-flex">
            <div className="m-1">
              <DatePicker
                value={filterDate.start}
                endDate={filterDate.end}
                onChange={setFilterDate}
                placeholder={'Filter tanggal mulai-akhir'}
                range
              />
            </div>
            <div className="m-1">
              <button
                onClick={() => getReport()}
                className="btn btn-primary-f text-nowrap">
                <i className="fa fa-search"></i> Lihat
              </button>
            </div>
          </div>
          <div>
            {/*<button onClick={getTransactionData} type="button" className="btn btn-success">*/}
            {/*    <CSVLink*/}
            {/*        data={bonusHarian.bonus ? bonusHarian.bonus : []}*/}
            {/*        ref={csvLink}*/}
            {/*        target='_blank'*/}
            {/*        filename='transactions.csv'*/}
            {/*    />*/}
            {/*    <i className="fas fa-file-csv"></i></button>*/}
          </div>
        </div>

        <div className="table-fixed custom-scrollbar table-responsive my-table">
          <div className="container-print media-print-p2" ref={printRef}>
            <PrintingHeader
              title={'Laporan Bonus Harian'}
              subtitle={
                bonusHarian?.member
                  ? `${bonusHarian?.member?.id_member} - ${bonusHarian?.member?.nama}`
                  : ''
              }
              date={[filterDate.start, filterDate.end]}
              printBy={null}
              printAt={null}
            />
            {bonusHarian?.member && (
              <>
                <div
                  className="px-2 d-flex mt-5"
                  style={{ fontSize: '0.9rem' }}>
                  <div className="mr-2" style={{ width: '180px' }}>
                    Akumulasi Bonus
                  </div>
                  <div className="mr-2">:</div>
                  <div className="font-weight-bold">
                    {formatCurrency(bonusHarian?.akumulasi)}
                  </div>
                </div>
              </>
            )}

            <div className="bt-table mt-4">
              <BootstrapTable
                className="bt-table"
                bootstrap4
                hover
                condensed
                noDataIndication={() => {
                  return 'No data';
                }}
                bordered={false}
                keyField="no_order"
                data={bonusHarian?.bonus || []}
                columns={columns}
              // pagination={paginationFactory()}
              />
            </div>
            <div
              className="px-2 d-flex align-items-center mb-4"
              style={{ fontSize: '0.85rem' }}>
              <div className="mr-2" style={{ width: '180px' }}>
                Tanggal Bergabung
              </div>
              <div className="mr-2">:</div>
              <div
                className="font-weight-bold d-flex align-items-center gap-2"
                style={{ width: '60%' }}>
                <span style={{ marginTop: '3px' }}>
                  {show
                    ? formatDateOnly(bonusHarian?.member?.tgl_join)
                    : '************'}
                </span>
                <button
                  className="btn btn-primary-f text-nowrap pt-2 pb-2 ml-2 "
                  style={{ fontSize: '10px', fontWeight: 'bold' }}
                  onClick={() => setShow(!show)}>
                  <i
                    className={`fa ${show ? 'fa-caret-down' : 'fa-caret-up'
                      } mr-1`}></i>
                  <span>{show ? 'Hide' : 'Show'}</span>
                </button>
              </div>
            </div>

            {/*<BonusPending data={data} />*/}
            {/*{*/}
            {/*    jenis?.value === 'pending' ? <BonusPending data={data} />*/}
            {/*        : jenis?.value === 'payout' ? <BonusPaid data={data} />*/}
            {/*            : jenis?.value === 'pending-member' ? <BonusPendingPermember data={data} />*/}
            {/*                : jenis?.value === 'payout-member' ? <BonusPaidPermember data={data} />*/}
            {/*                    : "payout"*/}
            {/*}*/}
          </div>
        </div>
      </CardBasic>
    </div>
  );
};

export default BonusHarian;
